import { useEffect } from "react";
import { getSocios } from "../../../api/Cadastro";
import SocioForm from "./SocioForm";
import { Skeleton } from "@mui/material";

export default function SocioItem({
  fieldErrors,
  socios,
  idCliente,
  idPerfilLimiteOperacional,
  setDada,
  isLoading,
  frontendErrors,
  onClearError,
  onClearEnderecoError,
}) {
  const initSocios = async (idCliente, idPerfilLimiteOperacional) => {
    try {
      let response = await getSocios(idCliente, idPerfilLimiteOperacional);

      if (response.length > 0) setDada(response);
    } catch (error) {
      console.error("Response vazio ou inválido", error.message);
    }
  };

  useEffect(() => {
    initSocios(idCliente, idPerfilLimiteOperacional);
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          {Array.from({ length: 2 }, () => (
            <Skeleton animation="wave" height={80} />
          ))}
        </>
      ) : (
        <SocioForm
          fieldErrors={fieldErrors}
          identificaItem="Sócio"
          socios={socios}
          setSocios={setDada}
          title="Sócio(s)"
          tooltipAdd="Adicione um sócio"
          tooltipDelete="Remove o sócio selecionado"
          idPerfilLimiteOperacional={idPerfilLimiteOperacional}
          idCliente={idCliente}
          frontendErrors={frontendErrors}
          onClearError={onClearError}
          onClearEnderecoError={onClearEnderecoError}
        />
      )}
    </>
  );
}
